<template>
  <div class="main">
    <Nav />
    <div class="loginForm" v-if="showLoginForm">
      <div class="loginForm-box">
        <img
          src="../assets/img/close-icon.svg"
          alt=""
          @click="handleShowLoginForm"
          class="loginForm-close"
        />
        <p class="title">手机号快捷登录参与活动</p>
        <p class="desc">使用手机号快捷登录，无账号将自动注册</p>
        <input
          type="text"
          class="phone-number"
          placeholder="输入手机号码"
          v-model="phoneNumber"
        />
        <p class="veriPhone" v-show="showPhoneTip">{{ this.veriPhone }}</p>
        <div class="img-code-box">
          <input
            type="text"
            placeholder="输入图形验证码"
            class="imgCodeIpt"
            v-model="imgCodeNumber"
          />
          <img :src="randomImg" id="img-code" @click="changeImgCode" />
        </div>
        <p class="veriImg" v-show="showImgTip">{{ this.veriImg }}</p>
        <div class="veri-code-box">
          <input
            type="text"
            class="veri-code"
            placeholder="输入手机验证码"
            v-model="codeNumber"
            maxlength="6"
          />
          <button v-if="!isCounting" class="veri-btn" @click="sendCode">
            {{ this.veriBtn }}
          </button>
          <button v-if="isCounting" class="veri-btn-counting">
            {{ this.veriBtn }}
          </button>
        </div>
        <p class="veriCode" v-show="showCodeTip">{{ this.veriCode }}</p>
        <button class="login-btn" @click="handleLogin">注册登录</button>
        <a
          href="javascript:void(0);"
          class="user-login"
          @click="handleUserLoginShow"
          >账号密码登录</a
        >
      </div>
    </div>
    <div class="loginForm" id="userLoginForm" v-if="showUserLoginForm">
      <div class="loginForm-box">
        <img
          src="../assets/img/close-icon.svg"
          alt=""
          @click="handleShowUserLoginForm"
          class="loginForm-close"
        />
        <p class="title">账号密码登录参与活动</p>
        <p class="desc">使用虹软开放平台账号登录</p>
        <input
          type="text"
          class="user-number"
          placeholder="输入账号"
          v-model="userNumber"
        />
        <p class="veriUser" v-show="showUserTip">{{ this.veriUser }}</p>
        <input
          type="password"
          class="pwd-number"
          placeholder="输入密码"
          v-model="pwdNumber"
        />
        <p class="veriPwd" v-show="showPwdTip">{{ this.veriPwd }}</p>
        <button class="login-btn" @click="handleUserLogin">下一步</button>
        <a
          href="javascript:void(0);"
          class="user-login"
          @click="handlePhoneLoginShow"
          >手机号快捷登录</a
        >
      </div>
    </div>
    <div class="certifyCompanyForm" v-if="showCertifyCompanyForm">
      <div class="certifyCompanyForm-box">
        <img
          src="../assets/img/close-icon.svg"
          alt=""
          @click="handleCertifyCompanyFormClose"
          class="certifyCompanyForm-close"
        />
        <p class="certify-tip">完成企业认证后即可免费参与抽奖，</p>
        <p>建议您前往企业认证</p>
        <div>
          <button class="think" @click="handleCertifyCompanyFormClose">
            再想想
          </button>
          <button class="certify-company-btn" @click="toCertify">
            企业认证
          </button>
        </div>
      </div>
    </div>
    <div class="prizeForm" v-if="showRealPrizeForm">
      <div class="prizeForm-box">
        <img
          src="../assets/img/close-icon.svg"
          alt=""
          @click="handleRealPrizeFormClose"
          class="certifyCompanyForm-close"
        />
        <p class="text-1">恭喜！您获得</p>
        <p class="text-2">{{ this.prizeName }} 1份</p>
        <p class="text-3">
          实物奖品将于活动结束后30个工作日内由虹助手核实发放，
          优惠券奖品已放入您的账户，进入开发者中心即可查看使用
        </p>
        <button @click="toCoupon">我的优惠券奖品</button>
      </div>
    </div>
    <div class="prizeFormCode" v-if="showCodePrizeForm">
      <div class="prizeFormCode-box">
        <img
          src="../assets/img/close-icon.svg"
          alt=""
          @click="handlePrizeFormCodeClose"
          class="certifyCompanyForm-close"
        />
        <p class="text-1">恭喜！您获得</p>
        <p class="text-2">{{ this.prizeName }} 1份</p>
        <p class="text-3">优惠券已放入您的账户中，</p>
        <p class="text-4">进入开发者中心即可查看使用</p>
        <button @click="toCoupon">立即使用</button>
      </div>
    </div>
    <div class="prizeAlert" style="display: none">
      <div class="prizeAlert-box">
        <p>您已完成抽奖！无法重复抽奖哦~</p>
      </div>
    </div>
    <div class="inviteFriendAlert" style="display: none">
      <div class="inviteFriendAlert-box">
        <p>邀请链接已复制，粘贴可发送给好友</p>
      </div>
    </div>
    <div class="banner">
      <video src="../assets/img/banner.mp4" autoplay loop muted></video>
      <img src="../assets/img/banner-mobile.jpg" alt="" />
    </div>
    <div class="wrapper">
      <div class="publish">
        <img class="ball-1" src="../assets/img/ball-1.png" alt="" />
        <img class="rightblur" src="../assets/img/rightblur.png" alt="" />
        <div class="publish-content">
          <div class="publish-title">
            <p>4.1 重磅发布 性能再升级</p>
          </div>
          <ul>
            <li>
              <img src="../assets/img/publish-1.png" alt="" />
              <p>多人脸检测流畅度显著增强</p>
            </li>
            <li>
              <img src="../assets/img/publish-2.png" alt="" />
              <p>算法策略优化比对性能大幅提升</p>
            </li>
            <li>
              <img src="../assets/img/publish-3.png" alt="" />
              <p>支持远距离小人脸活体检测</p>
            </li>
            <li>
              <img src="../assets/img/publish-4.png" alt="" />
              <p>RGB/IR活体检测速度提高</p>
            </li>
          </ul>
          <a class="product-detail" href="https://ai.arcsoft.com.cn/product/arcface_pro.html" 
            @click="gtag('event', '查看产品详情', {'event_category' : '4.1试用活动', 'event_label' : 'click1'});">
            <span>查看产品详情 >></span>
          </a>
        </div>
      </div>
      <div class="opportunity">
        <div class="opportunity-title">
          <p>多重礼遇</p>
        </div>
        <div class="tab-change">
          <ul>
            <li data-to="first-module">幸运抽好礼</li>
            <li data-to="second-module">免费领正式码</li>
            <li data-to="third-module">认证领试用码</li>
          </ul>
        </div>
        <div
          class="zhuanpan"
          id="first-module">
          <LuckyWheel
            ref="LuckyWheel"
            class="LuckyWheel"
            :blocks="blocks"
            :prizes="prizes"
            :buttons="buttons"
            :defaultConfig="defaultConfig"
            @start="startCallBack"
            @end="endCallBack"
          />
        </div>
        <p class="zhuanpan-tip">{{ this.userPrizeContent }}</p>
        <div class="broadcast">
          <img src="../assets/img/speaker.png" alt="" />
          <el-carousel
            height="50px"
            direction="vertical"
            :autoplay="true"
            :interval="3000"
            indicator-position="none"
          >
            <el-carousel-item
              class="el-carousel-item"
              v-for="(item, index) in scrollData"
              :key="index"
            >
              <p class="medium">
                恭喜{{ item.userPhone }}获得{{ item.awardName }}
              </p>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <img class="ball-2" src="../assets/img/ball-2.png" alt="" />
      <div class="get-value-added-activation-code" id="second-module">
        <img class="leftblur" src="../assets/img/leftblur.png" alt="" />
        <div class="value-added-content">
          <div class="value-added-title">
            <p>免费领增值版激活码</p>
          </div>
          <img src="../assets/img/value-added-left.png" alt="" />
          <div class="right-content">
            <p>完成以下其中一项任务即可获得最新4.1增值版激活码1个</p>
            <div class="task-1">
              <p class="task-text">
                <span class="number">1. </span>
                针对本账号未激活的用户，完成&nbsp;&nbsp;
                <span>企业认证且进行首次试用码激活体验</span>
              </p>
              <div class="task-1-btn" @click="toCertify">
                <p>{{ certifyText }}</p>
              </div>
            </div>
            <div class="task-1 task-2">
              <p class="task-text">
                <span class="number">2. </span>
                针对本账号已激活的用户，邀请1位好友注册且完成试用码激活体验&nbsp;&nbsp;
                <span @click="helpFriendGuidance">
                  好友如何助力</span>
              </p>
              <div class="task-1-btn" @click="inviteFriend" v-if="inviteStatus1">
                <p 
                  class="inviteBox"
                  :data-clipboard-text="inviteLink"
                >
                  去邀请好友
                </p>
              </div>
              <div class="task-1-btn" v-if="inviteStatus2" @click="helpFriend">
                <p>助好友激活</p>
              </div>
              <div class="task-1-btn" v-if="inviteStatus3">
                <p>已获激活码</p>
              </div>
            </div>
            <p class="value-added-tip">
              激活码可用于Android平台，1个激活码仅用于1台设备，
              不可用于APP应用场景；完成以上任务后请联系虹助手领取激活码
            </p>
          </div>
        </div>
        <div class="value-added-content-mobile">
          <img src="../assets/img/value-added-left.png" alt="" />
          <div class="value-added-title">
            <p>免费领增值版激活码</p>
          </div>
          <p class="line1">完成以下其中一项任务</p>
          <p class="line2">即可获得最新4.1增值版激活码1个</p>
          <div class="task1">
            <p>1. 针对本账号未激活的用户</p>
            <p class="task1-detail">
              完成&nbsp;&nbsp;<span>企业认证且进行首次试用码激活体验</span>
            </p>
            <div class="activate-btn" @click="toCertify">
              <p>{{ certifyText }}</p>
            </div>
          </div>
          <div class="task1 task2">
            <p>2. 针对本账号已激活的用户</p>
            <p>邀请1位好友注册且完成试用码激活体验</p>
            <div class="activate-btn" v-if="inviteStatus1" @click="inviteFriend">
              <p
                class="inviteBox"
                :data-clipboard-text="inviteLink"
              >
                去邀请好友
              </p>
            </div>
            <div class="activate-btn" v-if="inviteStatus2" @click="helpFriend">
              <p>助好友激活</p>
            </div>
            <div class="activate-btn" v-if="inviteStatus3">
              <p>已获激活码</p>
            </div>
            <p class="tip">
              激活码可用于Android平台，
              1个激活码仅用于1台设备，不可用于APP应用场景；
              完成以上任务后请联系虹助手领取激活码
            </p>
          </div>
        </div>
      </div>
      <div class="get-trial-code" id="third-module">
        <div class="trial-code-content">
          <div class="trial-code-title">
            <p>认证领试用码大礼包</p>
          </div>
          <img src="../assets/img/gift.png" alt="" />
          <div class="right-content">
            <p>最新4.1增值版SDK试用码<span>12</span>个</p>
            <div class="trial-code-tip">
              <div>
                <p>活动期间，用户完成企业认证或个人认证，即可领取试用礼包，</p>
                <p>不同平台累计共可获取12个最新版本的增值版人脸试用码。</p>
                <p class="extra-tip">
                  （Android平台率先推出，其余平台持续上线）
                </p>
              </div>
              <div class="get-trial-btn" @click="getTrial" v-if="!this.hasEval">
                <p>立即领取</p>
              </div>
              <div class="get-trial-btn" @click="toUse" v-if="this.hasEval">
                <p>立即使用</p>
              </div>
            </div>
          </div>
        </div>
        <div class="trial-code-content-mobile">
          <div class="trial-code-title">
            <p>认证领试用码大礼包</p>
          </div>
          <img src="../assets/img/gift.png" alt="" />
          <p class="trial-code-number">
            最新4.1增值版SDK试用码&nbsp;<span>12</span>&nbsp;个
          </p>
          <p class="trial-code-tip">
            活动期间，用户完成企业认证或个人认证，即可领取试用礼包，
            不同平台累计共可获取12个最新版本的增值版人脸试用码。<span
              >（Android平台率先推出，其余平台持续上线）</span
            >
          </p>
          <div class="get-btn" @click="getTrial" v-if="!this.hasEval">
            <p>立即领取</p>
          </div>
          <div class="get-btn" @click="toUse" v-if="this.hasEval">
            <p>立即使用</p>
          </div>
        </div>
      </div>
      <div class="activity-question">
        <div class="activity-question-content">
          <img src="../assets/img/qrcode1.png" alt="" />
          <div class="right-content">
            <p>活动规则及增值版使用有疑问？ 扫码添加官方虹助手</p>
            <ul>
              <li>
                <img src="../assets/img/qr1.png" alt="" />
                <p>增值版激活码点对点发放</p>
              </li>
              <li>
                <img src="../assets/img/qr2.png" alt="" />
                <p>激活码和试用码使用答疑</p>
              </li>
              <li>
                <img src="../assets/img/qr3.png" alt="" />
                <p>社群抽奖、干货分享</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="activity-question-mobile">
        <p>活动规则及增值版使用有疑问？ 扫码添加官方虹助手</p>
        <img src="../assets/img/qrcode1.png" alt="" />
        <ul>
          <li>
            <img src="../assets/img/qr1.png" alt="" />
            <p>增值版激活码点对点发放</p>
          </li>
          <li>
            <img src="../assets/img/qr2.png" alt="" />
            <p>激活码和试用码使用答疑</p>
          </li>
          <li>
            <img src="../assets/img/qr3.png" alt="" />
            <p>社群抽奖、干货分享</p>
          </li>
        </ul>
      </div>

      <div class="activity-rule">
        <p class="title">活动细则</p>
        <div class="activity-time">
          <img src="../assets/img/time.png" alt="" />
          <p class="time-title">活动时间</p>
          <p>2021年6月23日-7月8日</p>
        </div>
        <div class="activity-group">
          <img src="../assets/img/group.png" alt="" />
          <p class="group-title">参与人群</p>
          <p>平台内所有用户</p>
        </div>
        <div class="prize-rule">
          <img src="../assets/img/icon1.png" alt="" />
          <p class="prize-title">抽奖奖品获取及发放规则</p>
        </div>
        <p class="first-title"><span>1. </span>奖品内容如下</p>
        <div class="prize-content">
          <div class="left-content">
            <p>奖品名</p>
            <div class="left-detail">
              <p>小米触屏音箱礼包</p>
            </div>
            <div class="left-detail">
              <p>4.1增值版激活码礼包</p>
            </div>
            <div class="left-detail">
              <p>虹软定制U盘礼包</p>
            </div>
            <div class="left-detail">
              <p>虹软定制充电宝礼包</p>
            </div>
            <div class="left-detail">
              <p>惊喜8折组合券包</p>
            </div>
            <div class="left-detail">
              <p>超值9折组合券包</p>
            </div>
          </div>
          <div class="right-content">
            <p>奖品内容</p>
            <div class="right-detail">
              <p>1） 小米触屏音箱1台 ￥249</p>
              <p>2） 优惠券组合B （增值版8折+APP版9折）</p>
            </div>
            <div class="right-detail">
              <p>1）4.1增值版激活码1个 ￥120</p>
              <p>2）优惠券组合A （增值版9折+APP版9折）</p>
            </div>
            <div class="right-detail">
              <p>1）虹软定制U盘1个 ￥80</p>
              <p>2）优惠券组合A（增值版9折+APP版9折）</p>
            </div>
            <div class="right-detail">
              <p>1) 虹软定制充电宝1个 ￥80</p>
              <p>2）优惠券组合A （增值版9折+APP版9折）</p>
            </div>
            <div class="right-detail onlyone">
              <p>优惠券组合B（增值版8折+APP版9折）</p>
            </div>
            <div class="right-detail onlyone">
              <p>优惠券组合A（增值版9折+APP版9折）</p>
            </div>
          </div>
        </div>
        <p class="first-title second-title">
          <span>2.</span>
          用户完成企业认证即可获得1次抽奖机会，本次抽奖100%中奖；
        </p>
        <p class="first-title multiline">
          <span>3.</span>
          用户通过抽奖获取实物礼品后，将由虹助手专人对接，核对礼品详情、收件人相关信息；
          在活动结束后30个工作日内发放，如遇到产品缺货，发货日期可能延后或发放等价值礼品；
        </p>
        <p class="first-title">
          <span>4.</span>
          用户通过抽奖获得的激活码将于活动结束后由虹助手审核无误后进行点对点发放；
        </p>
        <p class="first-title last added">
          <span>5.</span>
          用户通过抽奖获得的优惠券将及时发送至用户账户内，优惠券在活动期间有效，请在有效期内及时使用。
        </p>
        <div class="prize-rule">
          <img src="../assets/img/icon2.png" alt="" />
          <p class="prize-title valueAddedRule">增值版激活码赠送规则</p>
        </div>
        <p class="first-title">
          <span>1.</span>
          活动期间，用户完成以下其中一项任务即可获赠1个4.1增值版激活码：
        </p>
        <p class="first-title subtitle">
          1）针对本账号未激活的用户，完成企业认证且进行首次试用码激活；
        </p>
        <p class="first-title subtitle">
          2）针对本账号已激活的用户，用户邀请1位好友注册且完成试用码激活；
        </p>
        <p class="first-title subtitle">
          如活动期间用户同时完成以上2项任务，则可获得2个4.1增值版激活码
        </p>
        <p class="first-title multiline2">
          <span>2.</span>
          所获激活码可用于Android平台，一个激活码仅用于一台设备，不可用于APP应用场景；
          若该设备重置，激活码仍然生效；
        </p>
        <p class="first-title multiline2 third-title">
          <span>3.</span> 所获的增值版人脸识别SDK（ArcFace
          Pro）激活码可离线激活、离线使用，且永久装机授权；
        </p>
        <p class="first-title">
          <span>4.</span> 激活码将在活动结束后由虹助手审核无误后进行点对点发放。
        </p>
        <div class="prize-rule trialRule">
          <img src="../assets/img/flower.png" alt="" />
          <p class="prize-title">试用码领用规则</p>
        </div>
        <p class="first-title multiline2">
          <span>1.</span>
          用户完成企业认证或个人认证，即可领取人脸识别增值版试用码礼包。
          针对SDK的不同平台，每位用户可申请1次，共3个试用码；
        </p>
        <p class="first-title">
          <span>2.</span> 每个试用码自申请之日起有效期为90天；
        </p>
        <p class="first-title trial-code-last">
          <span>3.</span>
          试用码申请后需要在设备端激活使用，同一个试用码仅能在一台设备上使用。
        </p>
        <p class="notices">注意事项</p>
        <p class="first-title multiline3">
          1.如用户在活动中存在隐瞒、虚构、作弊、欺诈或通过其他非正常手段规避活动规则、获取不当利益的行为，
          例如：作弊领取、提供虚假信息、恶意套现、网络攻击、虚假交易等，虹软视觉开放平台有权取消用户的活动参与资格，
          撤销违规交易，回收相关资源和权益，追缴差价，必要时追究违规用户的法律责任；
        </p>
        <p class="first-title notices-last">
          2.虹软视觉开放平台在法律允许的范围内享有对本活动的解释权。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import Nav from "../components/nav";
export default {
  components: {
    Nav,
  },
  // provide(){
  //   return{
  //     reload: this.reload,
  //   }
  // },
  // inject: ['reload'],
  data() {
    return {
      isRouterAlive: true,
      isLogined: false,
      showLoginForm: false,
      showUserLoginForm: false,
      isCertifyCompany: false,
      showCertifyCompanyForm: false,
      showRealPrizeForm: false,
      showCodePrizeForm: false,
      hasEval: false,
      hasEvalActive: false,
      certifyText: "去认证激活",
      isExists: false, //是否抽过奖
      userPrizeContent: "完成企业认证即可参与抽奖",
      keyId: 0, //中奖id
      prizeName: "", //中奖物品名
      prizeIndex: 0, //转盘旋转index
      veriBtn: "获取短信验证码",
      veriUser: "",
      veriPwd: "",
      veriPhone: "",
      veriCode: "",
      veriImg: "",
      userNumber: "",
      pwdNumber: "",
      phoneNumber: "",
      codeNumber: "",
      imgCodeNumber: "",
      randomImg: "/ucenter/api/authimage",
      regDeviceType: 0,
      isBackTopShow: false,
      showUserTip: false,
      showPwdTip: false,
      showCodeTip: false,
      showPhoneTip: false,
      showInviteTips: false,
      showImgTip: false,
      showLoginForm: false,
      veriBtn: "获取短信验证码",
      isLogined: false,
      isCounting: false,
      isImgCodeTrue: false,
      inviteCode: "",
      inviteLink: "",
      inviteStatus1: true, //邀请状态1
      inviteStatus2: false, //邀请状态2
      inviteStatus3: false, //邀请状态3
      scrollData: [],
      prizes: [
        { name: "小米触屏音箱礼包" },
        { name: "虹软定制充电宝礼包" },
        { name: "4.1增值版激活码礼包" },
        { name: "惊喜8折组合券包" },
        { name: "虹软定制U盘礼包" },
        { name: "超值9折组合券包" },
      ],
      buttons: [
        {
          radius: "25%",
          imgs: [
            {
              src: require("../assets/img/point.png"),
              width: "350%",
              top: "-350%",
            },
          ],
        },
      ],
      blocks: [
        {
          imgs: [
            {
              src: require("../assets/img/spin-middle.png"),
              width: "100%",
              rotate: true,
            },
          ],
        },
      ],
      defaultConfig: {
        offsetDegree: 30,
      },
    };
  },
  created() {
    //判断用户当前登录状态
    this.queryUser();

    //查询中奖用户信息
    this.$axios
      .post("/operator/new-version/queryLotteryResult", {})
      .then((res) => {
        if (res.data.success == true) {
          this.scrollData = res.data.retObj;
        } else {
        }
      });
  },
  mounted() {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());

    if (document.location.href.indexOf("ai.arcsoft.com.cn") > 0) {
      gtag("config", "UA-7959274-33");
    } else {
      gtag("config", "UA-7959274-34");
    }
    $(".tab-change").on("click", "li", function (e) {
      var target = e.target;
      var id = $(target).data("to");
      $("html,body").scrollTop($("#" + id).offset().top - 153);
    });
    $(".main .wrapper .tab-change ul li").hover(
      function () {
        $(this).css("background-image", "none");
        $(this).css(
          "background-image",
          "linear-gradient(0deg, #EAD97B 0%, #D1A900 100%)"
        );
      },
      function () {
        $(this).css(
          "background-image",
          "linear-gradient(0deg, #ffce00 0%, #fff5bc 100%)"
        );
      }
    );
  },
  methods: {
    //获取邀请用户的信息
    getInvitateInfo() {
      this.$axios
        .post("/operator/new-version/getInvitateInfo", {})
        .then((res) => {
          if (res.data.retCode == -8801) {
            this.inviteStatus1 = true;
          } else if (res.data.retCode == -8101) {
            this.inviteStatus1 = false;
            this.inviteStatus2 = true;
          } else if (res.data.retCode == 100) {
            this.inviteStatus1 = false;
            this.inviteStatus3 = true;
          } else {
            this.inviteStatus1 = true;
          }
        });
    },
    queryUser() {
      this.$axios.post("/operator/new-version/query", {}).then((res) => {
        if (res.data.success == true) {
          if (res.data.retMsg == "用户未登录") {
            this.isLogined = false;
          } else {
            this.isLogined = true;
            this.showLoginForm = false;
            this.isCertifyCompany = res.data.retObj.isCertifyCompany;
            this.hasEval = res.data.retObj.hasEval;
            this.hasEvalActive = res.data.retObj.hasEvalActive;
            this.userPrizeContent =
              "恭喜！您已获得" + res.data.retObj.lotteryInfo.name;
            if (this.hasEvalActive) {
              this.certifyText = "已获激活码";
            }
            if (res.data.retObj.lotteryInfo.name) {
              this.isExists = true;
            }
          }
        }
      });
    },
    // reload(){
    //   this.isRouterAlive = false;
    //   this.$nextClick(function(){
    //     this.isRouterAlive = true;
    //   })
    // },
    //用户登录
    async handleLogin() {
      if (this.imgCodeNumber == "" || this.imgCodeNumber == null) {
        this.veriImg = "请输入图形验证码";
        this.showImgTip = true;
      }
      if (this.phoneNumber == "" || this.phoneNumber == null) {
        this.veriPhone = "请输入手机号";
        this.showPhoneTip = true;
      }
      if (this.codeNumber == "" || this.codeNumber == null) {
        this.veriCode = "请输入验证码";
        this.showCodeTip = true;
      }
      if (this.phoneNumber && !/^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber)) {
        this.veriPhone = "手机号格式不正确";
        this.showPhoneTip = true;
      }
      /* 用户登录 */
      if (
        this.phoneNumber &&
        /^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber) == true &&
        this.isImgCodeTrue == true
      ) {
        this.showPhoneTip = false;
        this.showCodeTip = false;
        this.showImgTip = false;
        this.$axios
          .post("/ucenter/user/LoginForCode", {
            phone: this.phoneNumber,
            smsValidCode: this.codeNumber,
            regSource: 14,
            regDeviceType: 1,
            imgValidCode: this.imgCodeNumber,
          })
          .then((res) => {
            if (res.data.success == true) {
              this.getInvitateInfo();
              this.queryUser();
              // localStorage.setItem("userId", res.data.retObj.id);
              this.isLogined = true;
              this.showLoginForm = false;
            } else {
              this.veriCode = "验证码输入错误";
              this.showCodeTip = true;
            }
          });
      }
    },
    //用户账号密码登录
    handleUserLogin() {
      if (!this.userNumber) {
        this.showUserTip = true;
        this.veriUser = "请输入用户名";
      } else if (!this.pwdNumber) {
        this.showPwdTip = true;
        this.veriPwd = "请输入密码";
      } else {
        this.$axios
          .post("/ucenter/user/Login", {
            email: this.userNumber,
            passwd: this.pwdNumber,
          })
          .then((res) => {
            if (res.data.success == true) {
              this.getInvitateInfo();
              this.showUserLoginForm = false;
              this.isLogined = true;
              this.queryUser();
            } else {
              this.showPwdTip = true;
              this.veriPwd = "用户名或密码错误";
              this.showUserTip = false;
            }
          });
      }
    },
    /* 发送验证码 */
    async sendCode() {
      if (this.phoneNumber == "" || this.phoneNumber == null) {
        this.veriPhone = "请输入手机号";
        this.showPhoneTip = true;
      } else if (
        this.phoneNumber &&
        !/^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber)
      ) {
        this.veriPhone = "手机号格式不正确";
        this.showPhoneTip = true;
      } else {
        this.showPhoneTip = false;
      }
      if (this.imgCodeNumber == "" || this.imgCodeNumber == null) {
        this.veriImg = "请输入图形验证码";
        this.showImgTip = true;
        return;
      }
      if (this.phoneNumber && /^[1]([3-9])[0-9]{9}$/.test(this.phoneNumber)) {
        this.showPhoneTip = false;
        this.$axios
          .post("/ucenter/API/SMSService/SendRegKeyV2?t=" + Math.random(), {
            phoneNum: this.phoneNumber,
            imageCode: this.imgCodeNumber,
          })
          .then((res) => {
            if (res.data.success == false) {
              this.veriImg = "图形验证码错误";
              this.showImgTip = true;
            } else {
              this.isImgCodeTrue = true;
              this.showImgTip = false;
              this.isCounting = true;
              var time = 60;
              var countDown = setInterval(() => {
                time--;
                this.veriBtn = "重新发送" + time;
                if (time == 0) {
                  this.isCounting = false;
                  this.veriBtn = "获取短信验证码";
                  clearInterval(countDown);
                }
              }, 1000);
            }
          });
      }
    },
    //是否展示登录框及其文本提示
    handleShowLoginForm() {
      this.changeImgCode();
      this.showLoginForm = false;
      this.isImgCodeTrue = false;
      this.showPhoneTip = false;
      this.showCodeTip = false;
      this.showImgTip = false;
      this.phoneNumber = "";
      this.imgCodeNumber = "";
      this.codeNumber = "";
    },
    handleUserLoginShow() {
      this.showLoginForm = false;
      this.showUserLoginForm = true;
    },
    handlePhoneLoginShow() {
      this.showUserLoginForm = false;
      this.showLoginForm = true;
    },
    handleShowUserLoginForm() {
      this.showUserLoginForm = false;
    },
    //切换图形验证码
    changeImgCode() {
      // $("#img-code").attr("src", "/ucenter/api/authimage?" + Math.random());
      this.randomImg = `/ucenter/api/authimage?${Math.random()}`;
    },
    //关闭企业认证弹框
    handleCertifyCompanyFormClose() {
      this.showCertifyCompanyForm = false;
    },
    //关闭用户实物中奖信息弹框
    handleRealPrizeFormClose() {
      this.showRealPrizeForm = false;
    },
    //关闭用户券码中奖信息弹框
    handlePrizeFormCodeClose() {
      this.showCodePrizeForm = false;
    },
    //开始抽奖
    startCallBack() {
      gtag('event', '点击抽奖', {'event_category' : '4.1试用活动', 'event_label' : 'click1'});
      if (!this.isLogined) {
        this.showLoginForm = true;
      } else if (this.isLogined && !this.isCertifyCompany) {
        this.showCertifyCompanyForm = true;
      } else {
        //调抽奖接口
        if (!this.isExists) {
          this.$refs.LuckyWheel.play();
          this.$axios
            .post("/operator/new-version/lotteryAction", {})
            .then((res) => {
              if (res.data.success == true) {
                // localStorage.setItem("isExists", res.data.retObj.isExists);
                this.isExists = res.data.retObj.isExists;
                this.prizeName = res.data.retObj.award.name;
                this.keyId = res.data.retObj.award.keyId;
                if (this.prizeName.indexOf("小米触屏音箱礼包") != -1) {
                  this.prizeIndex = 6;
                } else if (this.prizeName.indexOf("虹软定制充电宝礼包") != -1) {
                  this.prizeIndex = 1;
                } else if (
                  this.prizeName.indexOf("4.1增值版激活码礼包") != -1
                ) {
                  this.prizeIndex = 2;
                } else if (this.prizeName.indexOf("惊喜8折组合券包") != -1) {
                  this.prizeIndex = 3;
                } else if (this.prizeName.indexOf("虹软定制U盘礼包") != -1) {
                  this.prizeIndex = 4;
                } else if (this.prizeName.indexOf("超值9折组合券包") != -1) {
                  this.prizeIndex = 5;
                }
              }
            });
          setTimeout(() => {
            this.$refs.LuckyWheel.stop(this.prizeIndex);
          }, 3000);
        } else {
          $(".prizeAlert").show().delay(2000).fadeOut();
        }
      }
    },
    endCallBack(prize) {
      if (
        this.keyId == 3 ||
        this.keyId == 5 ||
        this.keyId == 6 ||
        this.keyId == 7 ||
        this.keyId == 9
      ) {
        this.showCodePrizeForm = true;
      } else if (
        this.keyId == 1 ||
        this.keyId == 2 ||
        this.keyId == 4 ||
        this.keyId == 8
      ) {
        this.showRealPrizeForm = true;
      }
      //抽完奖后刷新用户中奖状态
      if (this.isExists) {
        this.userPrizeContent = "恭喜！您已获得" + prize.name;
        // localStorage.setItem("userPrizeContent", this.userPrizeContent);
      }
    },

    
    //跳转 去认证
    toCertify() {
      gtag("event", "去认证激活", {
        event_category: "4.1试用活动",
        event_label: "click1",
      });
      if (!this.isCertifyCompany) {
        window.location.href =
          "https://ai.arcsoft.com.cn/ucenter/resource/build/index.html#/accountCompany";
      } else if (!this.hasEval) {
        window.location.href =
          "https://ai.arcsoft.com.cn/ucenter/resource/build/index.html#/addTrialsdk/1007?from=index";
      } else if (!this.hasEvalActive) {
        window.location.href =
          "https://ai.arcsoft.com.cn/ucenter/resource/build/index.html#/application";
      }
    },
    //跳转 好友如何助力 进指南页
    helpFriendGuidance() {
      gtag("event", "好友如何助力", {
        event_category: "4.1试用活动",
        event_label: "click1",
      });
      window.location.href = "https://ai.arcsoft.com.cn/manual/docs#/247";
    },
    //跳转 助力好友激活 进指南页
    helpFriend() {
      window.location.href = "https://ai.arcsoft.com.cn/manual/docs#/247";
    },
    toUse() {
      if (!this.isLogined) {
        this.showLoginForm = true;
      } else {
        window.location.href =
          "https://ai.arcsoft.com.cn/ucenter/resource/build/index.html#/application";
      }
    },
    //跳转 进入优惠券页面
    toCoupon() {
      window.location.href =
        "https://ai.arcsoft.com.cn/ucenter/resource/build/index.html#/mycoupon";
    },
    //跳转 获取试用码
    getTrial() {
      gtag("event", "立即领取", {
        event_category: "4.1试用活动",
        event_label: "click1",
      });
      if (this.isLogined) {
        window.location.href =
          "https://ai.arcsoft.com.cn/ucenter/resource/build/index.html#/addTrialsdk/1007?from=index";
      } else {
        this.showLoginForm = true;
      }
    },
    //邀请好友
    inviteFriend() {
      gtag("event", "去邀请好友", {
        event_category: "4.1试用活动",
        event_label: "click1",
      });
      if (this.isLogined) {
        this.$axios
          .post("/operator/new-version/getInvitateLink", {})
          .then((res) => {
            if (res.data.success == true) {
              this.inviteCode = res.data.retObj;
              this.inviteLink = `https://ai.arcsoft.com.cn/operator/resource/2021/newversion/index.html#/helpfriend?invitecode=${this.inviteCode}`;
              let clipboard = new Clipboard(".inviteBox");
              clipboard.on("success", (e) => {
                $(".inviteFriendAlert").show().delay(3000).fadeOut();
                // 释放内存
                clipboard.destroy();
              });
              clipboard.on("error", (e) => {
                // 释放内存
                clipboard.destroy();
              });
            }
          });
      } else {
        this.showLoginForm = true;
      }
    },
  },
};
</script>

<style scoped>
.main {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.main .banner {
  width: 100%;
  position: relative;
}
.main .banner video {
  width: 100%;
  height: auto;
  vertical-align: middle;
}
.main .banner img {
  display: none;
}

.main .loginForm {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}
.main .loginForm .loginForm-box {
  position: relative;
  width: 384px;
  height: 400px;
  background-color: #9379fd;
  border-radius: 16px;
  overflow: hidden;
}
.main .loginForm .loginForm-box .title {
  margin-top: 48px;
  font-size: 22px;
  font-weight: bolder;
  color: #ffffff;
}
.main .loginForm .loginForm-box .desc {
  color: #d9d9d9;
  margin-top: 7px;
  font-size: 14px;
  margin-bottom: 32px;
}

.main .loginForm .loginForm-box .img-code-box {
  display: flex;
  align-items: center;
  width: 256px;
  height: 32px;
  box-sizing: border-box;
  margin: 0 auto 24px;
}

.main .loginForm .loginForm-box .img-code-box input {
  width: 152px;
  height: 32px;
  border-radius: 2px;
  border: solid 1px #ffffff;
  box-sizing: border-box;
  padding-left: 10px;
  background-color: transparent;
  outline: none;
}

.main .loginForm .loginForm-box .img-code-box img {
  width: 100px;
  height: 32px;
  background-color: #ffffff;
  margin-left: 4px;
}

.main .loginForm .loginForm-box .veri-code-box {
  display: flex;
  /* align-items: center; */
  width: 256px;
  height: 32px;
  box-sizing: border-box;
  margin: 0 auto 24px;
}

.main .loginForm .loginForm-box .phone-number,
.user-number,
.pwd-number .main .loginForm .loginForm-box .veri-code {
  width: 256px;
  height: 32px;
  background-color: transparent;
  margin-bottom: 24px;
  border-radius: 2px;
  outline: none;
  border: solid 1px #ffffff;
  padding-left: 10px;
  color: #fff;
  box-sizing: border-box;
}

.main .loginForm .loginForm-box .pwd-number {
  width: 256px;
  height: 32px;
  background-color: transparent;
  margin-bottom: 24px;
  border-radius: 2px;
  outline: none;
  border: solid 1px #ffffff;
  padding-left: 10px;
  color: #fff;
  box-sizing: border-box;
}

.main .loginForm .loginForm-box .user-number::placeholder {
  color: #ffffff;
  opacity: 0.5;
}

.main .loginForm .loginForm-box .pwd-number::placeholder {
  color: #ffffff;
  opacity: 0.5;
}

.main .loginForm .loginForm-box .phone-number::placeholder {
  color: #ffffff;
  opacity: 0.5;
}

.main .loginForm .loginForm-box .img-code-box input::placeholder {
  color: #ffffff;
  opacity: 0.5;
}

.main .loginForm .loginForm-box .veri-code::placeholder {
  color: #ffffff;
  opacity: 0.5;
}

.main .loginForm .loginForm-box .veri-code {
  width: 152px;
  height: 37px;
  cursor: pointer;
  background-color: transparent;
  border-radius: 2px;
  outline: none;
  border: solid 1px #ffffff;
  padding-left: 10px;
  color: #fff;
  box-sizing: border-box;
}
.main .loginForm .loginForm-box .veri-btn {
  width: 152px;
  height: 37px;
  cursor: pointer;
  background-color: transparent;
  border: solid 1px #fff258;
  color: #ffd831;
  border-radius: 3px;
  outline: none;
  padding: 10px 6px;
  font-size: 12px;
}

.main .loginForm .loginForm-box .veri-btn {
  margin-left: 4px;
}
.main .loginForm .loginForm-box .veri-btn-counting {
  width: 152px;
  height: 37px;
  background-color: transparent;
  border: solid 1px #fff258;
  color: #ffd831;
  border-radius: 3px;
  margin-left: 4px;
  outline: none;
}

.main .loginForm .loginForm-box .loginForm-close {
  display: block;
  float: right;
  cursor: pointer;
  height: 18px;
  margin: 13px;
}
.main .loginForm .loginForm-box .login-btn {
  display: block;
  font-size: 14px;
  width: 256px;
  height: 33px;
  margin: 0 auto;
  margin-bottom: 21px;
  margin-top: 3px;
  color: #6638bf;
  font-weight: 700;
  letter-spacing: 1px;
  cursor: pointer;
  border: none;
  outline: none;
  background-image: linear-gradient(0deg, #ffdc14 0%, #ffce00 100%);
  border-radius: 2px;
  box-sizing: border-box;
}

.main #userLoginForm .loginForm-box .login-btn {
  margin-bottom: 69px !important;
}

.main .loginForm .loginForm-box .user-login {
  width: 72px;
  height: 12px;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0px;
  color: #ffffff;
}

.main .loginForm .loginForm-box .veriPhone,
.main .loginForm .loginForm-box .veriCode,
.veriUser,
.veriPwd .main .loginForm .loginForm-box .veriImg {
  position: absolute;
  left: 64px;
  color: red;
  font-size: 13px;
}

.main .loginForm .loginForm-box .veriPhone {
  margin-top: -25px;
}
.main .loginForm .loginForm-box .veriPwd {
  color: red;
  font-size: 13px;
  text-align: left;
  margin-left: 64px;
  margin-top: -22px;
}
.main .loginForm .loginForm-box .veriUser {
  margin-top: -22px;
}
.main .loginForm .loginForm-box .veriCode,
.veriPwd {
  margin-top: -20px;
}
.main .loginForm .loginForm-box .veriImg {
  top: 224px;
}

.main .certifyCompanyForm {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.main .certifyCompanyForm .certifyCompanyForm-box {
  width: 416px;
  height: 224px;
  background-color: #9379fd;
  border-radius: 16px;
  position: relative;
}

.main .certifyCompanyForm .certifyCompanyForm-box .certifyCompanyForm-close {
  display: block;
  float: right;
  cursor: pointer;
  height: 18px;
  margin: 13px;
}

.main .certifyCompanyForm .certifyCompanyForm-box p {
  width: 288px;
  height: 20px;
  font-size: 18px;
  font-weight: normal;
  line-height: 20px;
  letter-spacing: 0px;
  color: #ffffff;
  text-align: center;
  margin: 0 auto;
}

.main .certifyCompanyForm .certifyCompanyForm-box .certify-tip {
  margin-top: 64px;
  margin-bottom: 10px;
}

.main .certifyCompanyForm .certifyCompanyForm-box div {
  display: flex;
  margin-top: 35px;
}

.main .certifyCompanyForm .certifyCompanyForm-box div .think {
  width: 108px;
  height: 32px;
  border-radius: 2px;
  border: solid 1px #ffffff;
  margin-left: 76px;
  font-size: 16px;
  line-height: 32px;
  letter-spacing: 0px;
  color: #ffffff;
  background-color: transparent;
}

.main .certifyCompanyForm .certifyCompanyForm-box div .certify-company-btn {
  width: 108px;
  height: 32px;
  border-radius: 2px;
  border: none;
  outline: none;
  background-image: linear-gradient(0deg, #ffdc14 0%, #ffce00 100%);
  margin-left: 40px;
  font-size: 16px;
  font-weight: 700;
  line-height: 27px;
  letter-spacing: 2px;
  color: #6638bf;
}

.main .prizeForm {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.main .prizeForm .prizeForm-box {
  width: 416px;
  height: 234px;
  background-color: #9379fd;
  border-radius: 16px;
}

.main .prizeForm .prizeForm-box img {
  display: block;
  float: right;
  cursor: pointer;
  height: 18px;
  margin: 13px;
}

.main .prizeForm .prizeForm-box .text-1 {
  width: 96px;
  height: 16px;
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0px;
  color: #ffffff;
  margin: 48px auto 8px;
}

.main .prizeForm .prizeForm-box .text-2 {
  min-width: 235px;
  max-width: 375px;
  height: 25px;
  line-height: 25px;
  font-size: 24px;
  font-weight: 520;
  letter-spacing: 0px;
  color: #ffdd00;
  margin: 0 auto;
}

.main .prizeForm .prizeForm-box .text-3 {
  width: 366px;
  height: 45px;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 0.8;
  margin: 0 auto;
  margin-top: 16px;
}

.main .prizeForm .prizeForm-box button {
  display: block;
  font-size: 14px;
  width: 256px;
  height: 33px;
  margin: 16px auto 21px;
  color: #6638bf;
  font-weight: 700;
  letter-spacing: 1px;
  cursor: pointer;
  border: none;
  outline: none;
  background-image: linear-gradient(0deg, #ffdc14 0%, #ffce00 100%);
  border-radius: 2px;
  box-sizing: border-box;
}

.main .prizeFormCode {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.main .prizeFormCode .prizeFormCode-box {
  width: 416px;
  height: 234px;
  background-color: #9379fd;
  border-radius: 16px;
}

.main .prizeFormCode .prizeFormCode-box img {
  display: block;
  float: right;
  cursor: pointer;
  height: 18px;
  margin: 13px;
}

.main .prizeFormCode .prizeFormCode-box .text-1 {
  width: 96px;
  height: 16px;
  font-size: 16px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0px;
  color: #ffffff;
  margin: 48px auto 8px;
}

.main .prizeFormCode .prizeFormCode-box .text-2 {
  max-width: 375px;
  min-width: 235px;
  height: 25px;
  line-height: 25px;
  font-size: 24px;
  font-weight: 520;
  letter-spacing: 0px;
  color: #ffdd00;
  margin: 0 auto;
}

.main .prizeFormCode .prizeFormCode-box .text-3,
.text-4 {
  width: 182px;
  height: 16px;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0px;
  color: #ffffff;
  opacity: 0.8;
  margin: 0 auto;
}

.main .prizeFormCode .prizeFormCode-box .text-3 {
  margin-top: 16px;
  padding-left: 4px;
}

.main .prizeFormCode .prizeFormCode-box .text-4 {
  margin-top: 8px;
}

.main .prizeFormCode .prizeFormCode-box button {
  display: block;
  font-size: 14px;
  width: 256px;
  height: 33px;
  margin: 16px auto 21px;
  color: #6638bf;
  font-weight: 700;
  letter-spacing: 1px;
  cursor: pointer;
  border: none;
  outline: none;
  background-image: linear-gradient(0deg, #ffdc14 0%, #ffce00 100%);
  border-radius: 2px;
  box-sizing: border-box;
}

.main .prizeAlert {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.main .prizeAlert .prizeAlert-box {
  width: 384px;
  height: 80px;
  background-color: #9379fd;
  border-radius: 16px;
}

.main .prizeAlert .prizeAlert-box p {
  width: 265px;
  height: 18px;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: 0px;
  color: #ffffff;
  margin: 31px auto;
}

.main .inviteFriendAlert {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.main .inviteFriendAlert .inviteFriendAlert-box {
  width: 384px;
  height: 80px;
  background-color: #9379fd;
  border-radius: 16px;
}

.main .inviteFriendAlert .inviteFriendAlert-box p {
  width: 288px;
  height: 18px;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: 0px;
  color: #ffffff;
  margin: 31px auto;
}

.main .wrapper {
  width: 100%;
  height: 4600px;
  background-image: linear-gradient(#a074f7, #655be0);
  position: relative;
}
.main .wrapper .publish {
  width: 100%;
  height: 434px;
  position: relative;
}
.main .wrapper .publish-content {
  width: 1279px;
  height: 331px;
  background-image: url(../assets/img/publish-content-bg.png);
  opacity: 1.6;
  margin: 0 auto;
  position: relative;
  top: 110px;
}
.main .wrapper .publish-title {
  width: 600px;
  height: 120px;
  border-radius: 32px;
  margin: 0 auto;
  background-image: url(../assets/img/publish-title-bg.png);
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top: -85px;
  left: 326px;
  z-index: 999;
}
.main .wrapper .publish-title p {
  width: 430px;
  height: 36px;
  font-size: 36px;
  line-height: 36px;
  letter-spacing: 2px;
  color: #ffffff;
  padding-top: 60px;
  margin-left: 60px;
}
.main .wrapper .publish-content ul {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 1180px;
  height: 158px;
  margin: 0 auto;
  padding-top: 76px;
  padding-bottom: 40px;
}
.main .wrapper .publish-content ul li {
  width: 252px;
  height: 158px;
  list-style-type: none;
}
.main .wrapper .publish-content ul li img {
  width: 120px;
  height: 120px;
}
.main .wrapper .publish-content ul li p {
  width: 252px;
  height: 18px;
  font-size: 18px;
  line-height: 18px;
  color: #151515;
}
.main .wrapper .publish-content .product-detail {
  width: 155px;
  height: 35px;
  border-radius: 22px;
  border: solid 1px #797979;
  margin: 0 auto;
  display: block;
}
.main .wrapper .publish-content .product-detail span {
  width: 103px;
  height: 35px;
  text-decoration: underline;
  font-size: 14px;
  line-height: 35px;
  color: #6f6f6f;
  margin: 0 auto;
  cursor: pointer;
}

.main .wrapper .ball-1 {
  width: 61px;
  height: 61px;
  position: absolute;
  top: 62px;
  right: 167px;
}

.main .wrapper .rightblur {
  width: 614px;
  height: 702px;
  position: absolute;
  top: 180px;
  right: 0;
  z-index: 0;
}

.main .wrapper .opportunity .opportunity-title {
  background-image: url(../assets/img/opportunity-title-bg.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 410px;
  height: 105px;
  margin: 80px auto 0;
}
.main .wrapper .opportunity .opportunity-title p {
  width: 160px;
  height: 36px;
  font-size: 36px;
  line-height: 36px;
  letter-spacing: 2px;
  color: #ffffff;
  padding-top: 53px;
  padding-left: 85px;
}
.main .wrapper .tab-change {
  width: 100%;
  height: 40px;
  margin: 43px auto 0;
  position: relative;
}
.main .wrapper .tab-change ul {
  display: flex;
  justify-content: center;
  width: 640px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}
.main .wrapper .tab-change ul li {
  list-style-type: none;
  width: 160px;
  height: 40px;
  line-height: 40px;
  background-image: linear-gradient(0deg, #ffce00 0%, #fff5bc 100%);
  border-radius: 2px;
  font-size: 18px;
  letter-spacing: 2px;
  color: #6638bf;
  font-weight: 700;
  padding: 6px 14px;
  cursor: default;
}
/* .main .wrapper .tab-change ul li:hover{
  background-color: pink;
} */
.main .wrapper .tab-change ul li:not(:last-child) {
  margin-right: 80px;
}
.main .wrapper .zhuanpan {
  width: 980px;
  background-image: url(../assets/img/zhuanpan-bg.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin: 0 auto;
}
.main .wrapper .zhuanpan .LuckyWheel {
  margin: 51px auto 0;
  width: 520px;
  height: 520px;
  padding-right: 47px;
  box-sizing: border-box;
}

.main .wrapper .zhuanpan-tip {
  min-width: 215px;
  max-width: 300px;
  height: 14px;
  font-size: 14px;
  line-height: 14px;
  color: #ffffff;
  margin: 32px auto 51px;
}
.main .wrapper .broadcast {
  width: 515px;
  height: 100px;
  background-image: url(../assets/img/broadcast.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin: 0 auto;
  position: relative;
}
.main .wrapper .broadcast img {
  width: 19px;
  height: 18px;
  position: absolute;
  top: 16px;
  left: 41px;
}
.main .wrapper .broadcast .el-carousel-item {
  top: 35%;
}
.main .wrapper .broadcast p {
  width: 100%;
  height: 18px;
  font-size: 18px;
  line-height: 18px;
  color: #ffffff;
  text-align: left;
  padding-left: 80px;
}
.main .wrapper .ball-2 {
  position: absolute;
  width: 155px;
  height: 155px;
  top: 1339px;
  left: -9px;
}

.main .wrapper .get-value-added-activation-code {
  width: 100%;
  margin-top: 120px;
  position: relative;
}

.main .wrapper .get-value-added-activation-code .leftblur {
  width: 614px;
  height: 702px;
  position: absolute;
  top: 63px;
  left: 0;
}

.main .wrapper .get-value-added-activation-code .value-added-content,
.trial-code-content {
  width: 1279px;
  height: 280px;
  margin: 0 auto;
  background-image: url(../assets/img/value-added-bg.png);
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
}

.main .wrapper .get-value-added-activation-code .value-added-content-mobile {
  display: none;
}

.main
  .wrapper
  .get-value-added-activation-code
  .value-added-content
  .value-added-title {
  width: 373px;
  height: 73px;
  background-image: url(../assets/img/value-added-title-bg.png);
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  left: 454px;
  top: -55px;
}

.main
  .wrapper
  .get-value-added-activation-code
  .value-added-content
  .value-added-title
  p {
  width: 368px;
  height: 73px;
  font-size: 26px;
  line-height: 73px;
  letter-spacing: 3px;
  color: #ffffff;
}

.main .wrapper .get-value-added-activation-code .value-added-content img {
  width: 186px;
  height: 121px;
  margin-left: 92px;
  margin-right: 16px;
}

.main
  .wrapper
  .get-value-added-activation-code
  .value-added-content
  .right-content
  p {
  width: 452px;
  height: 18px;
  font-size: 18px;
  line-height: 18px;
  color: #ffffff;
  cursor: auto;
}

.main
  .wrapper
  .get-value-added-activation-code
  .value-added-content
  .right-content
  .task-1 {
  width: 891px;
  height: 43px;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 22px;
  display: flex;
  padding-left: 20px;
  justify-content: space-between;
  box-sizing: border-box;
  margin-top: 35px;
}

.main
  .wrapper
  .get-value-added-activation-code
  .value-added-content
  .right-content
  .task-1
  .task-text {
  width: 722px;
  height: 43px;
  font-size: 18px;
  line-height: 40px;
  color: #ffffff;
  margin-top: 0;
  text-align: left;
}

.main
  .wrapper
  .get-value-added-activation-code
  .value-added-content
  .right-content
  .task-1
  .task-text
  .number {
  font-size: 28px;
  font-weight: 700;
}

.main
  .wrapper
  .get-value-added-activation-code
  .value-added-content
  .right-content
  .task-1
  .task-text
  span:last-child {
  color: #ffed99;
  cursor: auto;
}

.main
  .wrapper
  .get-value-added-activation-code
  .value-added-content
  .right-content
  .task-1
  .task-1-btn {
  width: 160px;
  height: 43px;
  background-image: linear-gradient(0deg, #ffce00 0%, #fff5bc 100%);
  border-radius: 22px;
  cursor: pointer;
}

.main
  .wrapper
  .get-value-added-activation-code
  .value-added-content
  .right-content
  .task-1
  .task-1-btn
  p {
  width: 108px;
  height: 43px;
  font-size: 18px;
  line-height: 43px;
  letter-spacing: 2px;
  color: #6638bf;
  margin: 0 auto;
  font-weight: 700;
  cursor: pointer;
}

.main
  .wrapper
  .get-value-added-activation-code
  .value-added-content
  .right-content
  .task-2 {
  margin-top: 15px;
}

.main
  .wrapper
  .get-value-added-activation-code
  .value-added-content
  .right-content
  .task-2
  .task-text
  span:last-child {
  text-decoration: underline;
  cursor: pointer;
}

.main
  .wrapper
  .get-value-added-activation-code
  .value-added-content
  .right-content
  .value-added-tip {
  width: 765px;
  height: 14px;
  font-size: 14px;
  line-height: 14px;
  color: #ffffff;
  opacity: 0.8;
  margin-top: 24px;
}

.main .wrapper .get-trial-code {
  width: 100%;
  position: relative;
  margin-top: 181px;
}

.main .wrapper .get-trial-code .trial-code-content {
  display: flex;
}

.main .wrapper .get-trial-code .trial-code-content-mobile {
  display: none;
}

.main .wrapper .get-trial-code .trial-code-content .trial-code-title {
  width: 373px;
  height: 73px;
  background-image: url(../assets/img/value-added-title-bg.png);
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  left: 454px;
  top: -55px;
}

.main .wrapper .get-trial-code .trial-code-content .trial-code-title p {
  width: 368px;
  height: 73px;
  font-size: 26px;
  line-height: 73px;
  letter-spacing: 3px;
  color: #ffffff;
}

.main .wrapper .get-trial-code .trial-code-content img {
  width: 294px;
  height: 182px;
  margin-left: 136px;
}

.main .wrapper .get-trial-code .trial-code-content .right-content {
  margin-left: 75px;
}

.main .wrapper .get-trial-code .trial-code-content .right-content p {
  width: 278px;
  height: 18px;
  font-size: 18px;
  line-height: 18px;
  color: #ffffff;
}

.main
  .wrapper
  .get-trial-code
  .trial-code-content
  .right-content
  > p:first-child {
  font-weight: bolder;
}

.main .wrapper .get-trial-code .trial-code-content .right-content p > span {
  font-size: 28px;
  margin: 0 10px;
}

.main
  .wrapper
  .get-trial-code
  .trial-code-content
  .right-content
  .trial-code-tip {
  display: flex;
  margin-top: 30px;
}

.main
  .wrapper
  .get-trial-code
  .trial-code-content
  .right-content
  .trial-code-tip
  div
  > p {
  width: 508px;
  height: 38px;
  font-size: 18px;
  line-height: 38px;
  color: #ffffff;
  text-align: left;
}

.main
  .wrapper
  .get-trial-code
  .trial-code-content
  .right-content
  .trial-code-tip
  div
  .extra-tip {
  font-size: 14px;
}

.main
  .wrapper
  .get-trial-code
  .trial-code-content
  .right-content
  .trial-code-tip
  .get-trial-btn {
  width: 160px;
  height: 40px;
  background-image: linear-gradient(0deg, #ffdc14 0%, #ffce00 100%);
  border-radius: 20px;
  margin-top: 10px;
  cursor: pointer;
}

.main
  .wrapper
  .get-trial-code
  .trial-code-content
  .right-content
  .trial-code-tip
  .get-trial-btn
  p {
  width: 100px;
  height: 40px;
  font-size: 18px;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: 2px;
  color: #6638bf;
  margin: 0 auto;
  cursor: pointer;
  text-align: center;
}

.main .wrapper .activity-question {
  width: 100%;
  position: relative;
  margin-top: 113px;
  display: block;
}

.main .wrapper .activity-question-mobile {
  display: none;
}

.main .wrapper .activity-question .activity-question-content {
  margin: 0 auto;
  width: 910px;
  height: 300px;
  display: flex;
}

.main .wrapper .activity-question .activity-question-content > img {
  width: 300px;
  height: 300px;
  margin-right: 50px;
}

.main .wrapper .activity-question .activity-question-content .right-content p {
  width: 560px;
  height: 108px;
  font-size: 40px;
  line-height: 68px;
  color: #ffffff;
  text-align: left;
}

.main .wrapper .activity-question .activity-question-content .right-content ul {
  list-style-type: none;
}

.main
  .wrapper
  .activity-question
  .activity-question-content
  .right-content
  ul
  li {
  display: flex;
}

.main
  .wrapper
  .activity-question
  .activity-question-content
  .right-content
  ul
  li
  img {
  width: 19px;
  height: 18px;
  margin-right: 10px;
}

.main
  .wrapper
  .activity-question
  .activity-question-content
  .right-content
  ul
  li
  p {
  width: 198px;
  height: 18px;
  font-size: 18px;
  line-height: 18px;
  color: #ffffff;
}

.main
  .wrapper
  .activity-question
  .activity-question-content
  .right-content
  ul
  li:first-child {
  margin-top: 35px;
}

.main
  .wrapper
  .activity-question
  .activity-question-content
  .right-content
  ul
  li:not(:last-child) {
  margin-bottom: 25px;
}

.main .wrapper .activity-rule {
  display: block;
  width: 824px;
  height: 1630px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  margin: 112px auto 0;
  padding-bottom: 70px;
}

.main .wrapper .activity-rule .title {
  width: 105px;
  height: 22px;
  font-size: 22px;
  line-height: 22px;
  letter-spacing: 4px;
  color: #ffffff;
  margin: 0 auto;
  padding-top: 66px;
}

.main .wrapper .activity-rule .activity-time {
  display: flex;
  align-items: center;
  margin-left: 63px;
  margin-top: 66px;
}

.main .wrapper .activity-rule .activity-time img {
  width: 32px;
  height: 32px;
  margin-right: 28px;
}

.main .wrapper .activity-rule .activity-time .time-title {
  width: 100px;
  height: 20px;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 4px;
  color: #fed590;
  margin-right: 20px;
}

.main .wrapper .activity-rule .activity-time > p:last-child {
  width: 205px;
  height: 14px;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 3px;
  color: #ffffff;
  text-align: left;
}

.main .wrapper .activity-rule .activity-group {
  display: flex;
  align-items: center;
  margin-left: 63px;
  margin-top: 28px;
}

.main .wrapper .activity-rule .activity-group img {
  width: 32px;
  height: 32px;
  margin-right: 28px;
}

.main .wrapper .activity-rule .activity-group .group-title {
  width: 100px;
  height: 20px;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 4px;
  color: #fed590;
  margin-right: 20px;
}

.main .wrapper .activity-rule .activity-group > p:last-child {
  width: 205px;
  height: 14px;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 3px;
  color: #ffffff;
  text-align: left;
}

.main .wrapper .activity-rule .prize-rule {
  display: flex;
  align-items: center;
  margin-left: 63px;
  margin-top: 35px;
}

.main .wrapper .activity-rule .prize-rule.trialRule {
  margin-top: 45px;
}

.main .wrapper .activity-rule img {
  width: 32px;
  height: 32px;
  margin-right: 28px;
}

.main .wrapper .activity-rule .prize-title {
  width: 265px;
  height: 20px;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 4px;
  color: #fed590;
  margin-right: 20px;
  text-align: left;
}

.main .wrapper .activity-rule .first-title {
  width: 640px;
  height: 14px;
  font-size: 14px;
  letter-spacing: 0px;
  color: #ffffff;
  margin-left: 121px;
  margin-top: 20px;
  text-align: left;
}

.main .wrapper .activity-rule .third-title + p {
  margin-top: -20px !important;
}

.main .wrapper .activity-rule .second-title {
  margin-top: 10px !important;
}

.main .wrapper .activity-rule .added {
  margin-bottom: 67px !important;
}

.main .wrapper .activity-rule .first-title > span {
  font-size: 18px;
  font-weight: 700;
  color: #fed590;
}

.main .wrapper .activity-rule .prize-content {
  display: flex;
}

.main .wrapper .activity-rule .prize-content .left-content {
  margin-left: 122px;
  margin-right: 10px;
}

.main .wrapper .activity-rule .prize-content .left-content > p {
  width: 51px;
  height: 14px;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 3px;
  color: #ffffff;
  margin-top: 20px;
  margin-bottom: 10px;
}

.main .wrapper .activity-rule .prize-content .left-content .left-detail {
  width: 200px;
  height: 50px;
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 2px;
  margin-bottom: 10px;
}

.main .wrapper .activity-rule .prize-content .left-detail p {
  width: 165px;
  height: 14px;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 3px;
  color: #ffffff;
  padding: 18px 58px 18px 10px;
  text-align: left;
}

.main .wrapper .activity-rule .prize-content .right-content > p {
  width: 70px;
  height: 14px;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 3px;
  color: #ffffff;
  margin-top: 20px;
  margin-bottom: 10px;
}

.main .wrapper .activity-rule .prize-content .right-content .right-detail {
  width: 350px;
  height: 50px;
  background-color: rgba(255, 255, 255, 0.15);
  border-radius: 2px;
  margin-bottom: 10px;
}

.main .wrapper .activity-rule .prize-content .right-detail p {
  width: 345px;
  height: 14px;
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 3px;
  color: #ffffff;
  text-align: left;
  padding-left: 10px;
}

.main .wrapper .activity-rule .prize-content .right-detail p:first-child {
  padding-top: 8px;
}

.main .wrapper .activity-rule .prize-content .right-detail p:last-child {
  padding-top: 8px;
  padding-bottom: 8px;
}

.main
  .wrapper
  .activity-rule
  .prize-content
  .right-content
  .right-detail.onlyone {
  padding-top: 10px;
  box-sizing: border-box;
}

.main .wrapper .activity-rule .first-title.multiline {
  margin-bottom: 40px;
  line-height: 22px;
}

.main .wrapper .activity-rule .first-title.subtitle {
  margin-left: 150px;
}

.main .wrapper .activity-rule .first-title.multiline2 {
  margin-bottom: 40px;
}

.main .wrapper .activity-rule .notices {
  width: 78px;
  height: 16px;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 3px;
  color: #ffffff;
  margin-left: 63px;
  margin-top: 55px;
}

.main .wrapper .activity-rule .first-title.multiline3 {
  margin-bottom: 80px;
}

@media screen and (max-width: 750px) {
  .main .banner video {
    display: none;
  }
  .main .banner img {
    display: block;
    width: 100%;
    height: auto;
  }
  .main .loginForm .loginForm-box {
    width: 290px;
    height: 270px;
    border-radius: 8px;
    padding-bottom: 10px;
    box-sizing: border-box;
  }
  .main #userLoginForm .loginForm-box {
    height: 245px;
  }
  .main #userLoginForm .loginForm-box .user-number {
    width: 250px;
    height: 30px;
    margin-bottom: 18px;
  }
  .main #userLoginForm .loginForm-box .pwd-number {
    width: 250px;
    height: 30px;
    margin-bottom: 18px;
  }
  .main .loginForm .loginForm-box .title {
    width: 140px;
    margin: 25px 75px 10px;
    /* height: 14px; */
    /* font-size: 14px;
    line-height: 14px;
    letter-spacing: 0px; */
  }
  .main .loginForm .loginForm-box .loginForm-close {
    height: 12px;
  }
  .main .loginForm .loginForm-box .title {
    width: 154px;
    height: 14px;
    font-size: 14px;
    line-height: 14px;
    letter-spacing: 0px;
    margin: 25px auto 10px;
  }
  .main .loginForm .loginForm-box .desc {
    height: 11px;
    font-size: 11px;
    line-height: 11px;
    letter-spacing: 0px;
    margin: 0 auto 10px;
  }
  .main .loginForm .loginForm-box .phone-number {
    width: 250px;
    height: 30px;
    border-radius: 1px;
    margin-bottom: 10px;
  }

  .main .loginForm .loginForm-box .img-code-box {
    margin: 0 auto 10px;
  }

  .main .loginForm .loginForm-box .img-code-box input {
    width: 120px;
    height: 30px;
    border-radius: 1px;
    margin-left: 3px;
  }

  .main .loginForm .loginForm-box .veriUser {
    margin-left: -44px;
    margin-top: -18px;
  }

  .main .loginForm .loginForm-box .veriPwd {
    margin-left: 19px;
    margin-top: -17px;
  }

  .main .loginForm .loginForm-box .img-code-box img {
    width: 120px;
    height: 30px;
    /* background-color: rgba(255, 255, 255, 0.5); */
    border-radius: 1px;
    margin-left: 10px;
  }

  .main .loginForm .loginForm-box .veri-code-box {
    margin-bottom: 15px;
  }

  .main .loginForm .loginForm-box .veri-code {
    width: 120px;
    height: 30px;
    border-radius: 1px;
    margin-left: 3px;
  }

  .main .loginForm .loginForm-box .veri-btn {
    width: 120px;
    height: 30px;
    border-radius: 1px;
    margin-left: 10px;
    padding: 0;
  }

  .main .loginForm .loginForm-box .login-btn {
    width: 250px;
    height: 30px;
    font-size: 12px;
    margin-bottom: 10px;
  }
  .main #userLoginForm .loginForm-box .login-btn {
    margin-bottom: 10px !important;
  }

  .main .loginForm .loginForm-box .user-login {
    width: 66px;
    height: 11px;
    font-size: 11px;
    line-height: 11px;
    letter-spacing: 0px;
  }

  .main .certifyCompanyForm .certifyCompanyForm-box {
    width: 290px;
    height: 124px;
    border-radius: 8px;
  }

  .main .certifyCompanyForm .certifyCompanyForm-box .certifyCompanyForm-close {
    height: 12px;
    margin: 10px 10px 0;
  }

  .main .certifyCompanyForm .certifyCompanyForm-box .certify-tip {
    margin-top: 25px;
    margin-bottom: 5px;
  }

  .main .certifyCompanyForm .certifyCompanyForm-box p {
    width: 224px;
    height: 15px;
    font-size: 14px;
    line-height: 15px;
  }

  .main .certifyCompanyForm .certifyCompanyForm-box div {
    margin-top: 20px;
  }

  .main .certifyCompanyForm .certifyCompanyForm-box div .think {
    width: 120px;
    height: 30px;
    line-height: 30px;
    margin-left: 20px;
    font-size: 12px;
  }

  .main .certifyCompanyForm .certifyCompanyForm-box div .certify-company-btn {
    width: 120px;
    height: 30px;
    line-height: 35px;
    font-size: 12px;
    letter-spacing: 1px;
    margin-left: 10px;
  }

  .main .prizeForm .prizeForm-box {
    width: 290px;
    height: 196px;
    border-radius: 8px;
  }

  .main .prizeForm .prizeForm-box img {
    height: 15px;
  }

  .main .prizeForm .prizeForm-box .text-1 {
    width: 84px;
    height: 14px;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0px;
    margin: 25px auto 10px;
  }

  .main .prizeForm .prizeForm-box .text-2 {
    max-width: 270px;
    min-width: 170px;
    height: 18px;
    font-size: 17px;
    line-height: 18px;
    letter-spacing: 0px;
  }

  .main .prizeForm .prizeForm-box .text-3 {
    width: 250px;
    height: 44px;
    font-size: 11px;
    line-height: 17px;
    letter-spacing: 0px;
    text-align: left;
    margin-top: 15px;
  }

  .main .prizeForm .prizeForm-box button {
    width: 250px;
    height: 30px;
    font-size: 12px;
    margin: 20px auto;
  }

  .main .prizeFormCode .prizeFormCode-box {
    width: 290px;
    height: 180px;
    border-radius: 8px;
  }

  .main .prizeFormCode .prizeFormCode-box img {
    height: 15px;
  }

  .main .prizeFormCode .prizeFormCode-box .text-1 {
    width: 84px;
    height: 14px;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0px;
    margin: 25px auto 10px;
  }

  .main .prizeFormCode .prizeFormCode-box .text-2 {
    width: 170px;
    height: 18px;
    font-size: 17px;
    line-height: 18px;
    letter-spacing: 0px;
  }

  .main .prizeFormCode .prizeFormCode-box .text-3 {
    width: 250px;
    height: 12px;
    font-size: 11px;
    line-height: 12px;
    margin-top: 15px;
  }

  .main .prizeFormCode .prizeFormCode-box .text-4 {
    width: 250px;
    height: 12px;
    font-size: 11px;
    line-height: 12px;
    margin-top: 5px;
  }

  .main .prizeFormCode .prizeFormCode-box button {
    width: 250px;
    height: 30px;
    font-size: 12px;
    margin: 20px auto;
  }

  .main .prizeAlert .prizeAlert-box {
    width: 290px;
    height: 60px;
    border-radius: 8px;
  }

  .main .prizeAlert .prizeAlert-box p {
    margin: 20px auto;
    font-size: 14px;
  }

  .main .inviteFriendAlert .inviteFriendAlert-box {
    width: 290px;
    height: 60px;
    border-radius: 8px;
  }

  .main .inviteFriendAlert .inviteFriendAlert-box p {
    margin: 20px auto;
    font-size: 14px;
  }

  .main .wrapper {
    height: 3270px;
  }
  .main .wrapper .publish {
    height: 345px;
  }
  .main .wrapper .ball-1 {
    display: none;
  }
  .main .wrapper .rightblur {
    display: none;
  }
  .main .wrapper .publish-content {
    width: 280px;
    height: 350px;
    background-image: url(../assets/img/publish-content-bg-mobile1.png);
    /* background-color: rgba(255, 255, 255, 0.49); */
    background-size: 100% 100%;
    background-repeat: no-repeat;
    top: 56px;
    padding-top: 38px;
    padding-bottom: 37px;
    box-sizing: border-box;
  }
  .main .wrapper .publish-title {
    width: 307px;
    height: 52px;
    background-size: 100% auto;
    top: -37px;
    left: -13px;
    text-align: center;
  }
  .main .wrapper .publish-title p {
    width: 100%;
    height: 18px;
    font-size: 18px;
    line-height: 18px;
    letter-spacing: 1px;
    color: #ffffff;
    padding-top: 25px;
    margin-left: -5px;
    margin-right: 0;
  }
  .main .wrapper .publish-content ul {
    width: 230px;
    height: 226px;
    flex-wrap: wrap;
    padding-top: 0;
    padding-bottom: 0;
  }
  .main .wrapper .publish-content ul li {
    width: 96px;
    height: 103px;
    list-style-type: none;
  }
  .main .wrapper .publish-content ul li:nth-child(n + 3) {
    margin-top: 20px;
  }
  .main .wrapper .publish-content ul li img {
    width: 60px;
    height: 60px;
  }
  .main .wrapper .publish-content ul li p {
    width: 96px;
    height: 33px;
    font-size: 12px;
    line-height: 21px;
  }
  .main .wrapper .publish-content .product-detail {
    width: 78px;
    height: 18px;
    border-radius: 11px;
    margin-top: 25px;
    margin-bottom: 15px;
    padding-bottom: 5px;
  }
  .main .wrapper .publish-content .product-detail span {
    width: 52px;
    height: 18px;
    font-size: 7px;
    line-height: 18px;
    letter-spacing: 0px;
    color: #dddddd;
    cursor: pointer;
  }
  .main .wrapper .ball-2 {
    display: none;
  }
  .main .wrapper .get-value-added-activation-code .leftblur {
    display: none;
  }
  .main .wrapper .opportunity .opportunity-title {
    width: 191px;
    height: 54px;
    margin: 85px auto 0;
  }
  .main .wrapper .opportunity .opportunity-title p {
    width: 100%;
    font-size: 18px;
    line-height: 54px;
    letter-spacing: 1px;
    padding-top: 10px;
    padding-left: 40px;
    text-align: left;
  }
  .main .wrapper .tab-change {
    margin: 0 auto;
  }
  .main .wrapper .tab-change ul {
    width: 315px;
    margin: 24px auto;
  }
  .main .wrapper .tab-change ul li {
    height: 20px;
    line-height: 20px;
    background-image: linear-gradient(0deg, #ffce00 0%, #fff5bc 100%);
    border-radius: 1px;
    font-size: 12px;
    color: #6638bf;
    font-weight: 700;
    letter-spacing: 1px;
    padding: 6px 8px;
    cursor: default;
  }
  .main .wrapper .tab-change ul li:not(:last-child) {
    margin-right: 15px;
  }
  .main .wrapper .zhuanpan {
    background-image: none;
    width: 260px;
    margin-top: -30px;
  }
  .main .wrapper .zhuanpan .LuckyWheel {
    width: 260px;
    height: 260px;
    margin: 60px auto 30px;
  }
  .main .wrapper .zhuanpan-tip {
    min-width: 175px;
    max-width: 200px;
    height: 12px;
    font-size: 11px;
    line-height: 12px;
    margin: 14px auto;
  }
  .main .wrapper .broadcast {
    width: 280px;
    height: 57px;
  }
  .main .wrapper .broadcast img {
    width: 10px;
    height: 9px;
    top: 8px;
    left: 21px;
  }
  .main .wrapper .broadcast .el-carousel-item {
    top: 15%;
    left: 10%;
  }
  .main .wrapper .broadcast p {
    width: 100%;
    height: 13px;
    font-size: 9px;
    line-height: 13px;
    text-align: left;
    padding-left: 14px;
  }
  .main .wrapper .get-value-added-activation-code {
    margin-top: 37px;
  }
  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content
    .value-added-title {
    width: 187px;
    height: 37px;
    left: 47px;
    top: -28px;
    background-size: 100% 100%;
  }
  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content
    .value-added-title
    p {
    width: 128px;
    height: 13px;
    font-size: 13px;
    line-height: 13px;
    letter-spacing: 1px;
    padding-top: 14px;
    padding-left: 30px;
  }
  .main .wrapper .get-value-added-activation-code .value-added-content {
    display: none;
  }
  .main .wrapper .get-value-added-activation-code .value-added-content-mobile {
    display: block;
    width: 280px;
    height: 464px;
    background-image: url(../assets/img/publish-content-bg-mobile1.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    margin: 0 auto;
  }
  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content-mobile
    .value-added-title {
    width: 187px;
    height: 37px;
    background-image: url(../assets/img/value-added-title-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -24px;
  }
  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content-mobile
    .value-added-title
    p {
    width: 128px;
    font-size: 13px;
    line-height: 37px;
    letter-spacing: 1px;
    color: #ffffff;
    padding-left: 29px;
  }
  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content-mobile
    img {
    width: 93px;
    height: 61px;
    margin-top: 25px;
    margin-bottom: 10px;
  }
  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content-mobile
    .line1,
  .line2 {
    height: 14px;
    font-size: 12px;
    font-weight: 700;
    line-height: 14px;
    color: #ffffff;
  }
  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content-mobile
    .line2 {
    margin-top: 10px;
    margin-bottom: 20px;
  }

  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content-mobile
    .task1 {
    width: 260px;
    height: 70px;
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 11px;
    margin: 0 auto;
    box-sizing: border-box;
    position: relative;
  }

  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content-mobile
    .task1
    p {
    height: 12px;
    font-size: 9px;
    line-height: 12px;
    color: #ffffff;
    padding-right: 10px;
  }
  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content-mobile
    .task1
    > p {
    padding-top: 15px;
    padding-left: 11px;
    text-align: left;
  }
  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content-mobile
    .task1
    p:nth-child(2) {
    padding-top: 7px;
    padding-left: 24px;
    text-align: left;
  }
  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content-mobile
    .task1
    .task1-detail
    > span {
    color: #fff258;
  }
  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content-mobile
    .task1
    .activate-btn {
    width: 80px;
    height: 22px;
    background-image: linear-gradient(0deg, #ffdc14 0%, #ffce00 100%);
    box-sizing: border-box;
    border-radius: 10px;
    position: absolute;
    top: 57px;
    left: 91px;
  }
  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content-mobile
    .task1
    .activate-btn
    > p {
    font-size: 12px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 1px;
    color: #6638bf;
    margin: 0 auto;
    text-align: center;
    padding-right: 0;
  }
  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content-mobile
    .task1.task2 {
    margin-top: 18px;
  }
  .main
    .wrapper
    .get-value-added-activation-code
    .value-added-content-mobile
    .tip {
    width: 239px !important;
    height: 58px !important;
    font-size: 12px !important;
    line-height: 20px !important;
    margin: 55px auto 17px;
    padding-top: 0 !important;
    padding-left: 0 !important;
    color: #ffffff;
    opacity: 0.8;
  }
  .main .wrapper .get-trial-code {
    margin-top: 67px;
  }
  .main .wrapper .get-trial-code .trial-code-content {
    display: none;
  }
  .main .wrapper .get-trial-code .trial-code-content-mobile {
    display: block;
    width: 280px;
    height: 334px;
    background-image: url(../assets/img/publish-content-bg-mobile2.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    box-sizing: border-box;
    margin: 0 auto;
  }
  .main .wrapper .get-trial-code .trial-code-content-mobile .trial-code-title {
    width: 187px;
    height: 37px;
    background-image: url(../assets/img/value-added-title-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: -24px;
  }
  .main
    .wrapper
    .get-trial-code
    .trial-code-content-mobile
    .trial-code-title
    p {
    width: 128px;
    font-size: 13px;
    line-height: 37px;
    letter-spacing: 1px;
    color: #ffffff;
    padding-left: 29px;
  }
  .main .wrapper .get-trial-code .trial-code-content-mobile img {
    width: 147px;
    height: 91px;
    margin: 30px auto 25px;
  }
  .main .wrapper .get-trial-code .trial-code-content-mobile .trial-code-number {
    margin: 0 auto;
    height: 12px;
    font-size: 12px;
    font-weight: 700;
    line-height: 12px;
    color: #ffffff;
  }
  .main
    .wrapper
    .get-trial-code
    .trial-code-content-mobile
    .trial-code-number
    > span {
    font-size: 17px;
  }
  .main .wrapper .get-trial-code .trial-code-content-mobile .trial-code-tip {
    height: 77px;
    font-size: 12px;
    line-height: 21px;
    color: #ffffff;
    text-align: left;
    margin: 15px 25px;
  }
  .main
    .wrapper
    .get-trial-code
    .trial-code-content-mobile
    .trial-code-tip
    > span {
    font-size: 10px;
    margin-left: -6px;
  }
  .main .wrapper .get-trial-code .trial-code-content-mobile .get-btn {
    width: 80px;
    height: 22px;
    margin: 0 auto;
    border-radius: 10px;
    background-image: linear-gradient(0deg, #ffdc14 0%, #ffce00 100%);
    box-sizing: border-box;
  }
  .main .wrapper .get-trial-code .trial-code-content-mobile .get-btn > p {
    font-size: 12px;
    font-weight: 700;
    line-height: 22px;
    letter-spacing: 1px;
    color: #6638bf;
  }
  .main .wrapper .activity-question {
    display: none;
  }
  .main .wrapper .activity-question-mobile {
    display: block;
    width: 100%;
  }
  .main .wrapper .activity-question-mobile > p {
    width: 280px;
    height: 63px;
    font-size: 20px;
    line-height: 34px;
    color: #ffffff;
    margin: 46px auto 20px;
  }
  .main .wrapper .activity-question-mobile > img {
    width: 150px;
    height: 150px;
    margin: 0 auto 17px;
  }
  .main .wrapper .activity-question-mobile ul {
    list-style-type: none;
    margin-left: 113px;
  }

  .main .wrapper .activity-question-mobile ul li {
    display: flex;
  }

  .main .wrapper .activity-question-mobile ul li img {
    width: 14px;
    height: 13px;
    margin-right: 6px;
  }

  .main .wrapper .activity-question-mobile ul li p {
    width: 132px;
    height: 12px;
    font-size: 12px;
    line-height: 12px;
    color: #ffffff;
    text-align: left;
  }

  .main .wrapper .activity-question-mobile ul li:not(:last-child) {
    margin-bottom: 19px;
  }

  .main .wrapper .activity-rule {
    width: 300px;
    height: 940px;
    border-radius: 4px;
    margin: 24px auto 0;
  }
  .main .wrapper .activity-rule .added {
    margin-bottom: 20px !important;
  }

  .main .wrapper .activity-rule .title {
    width: 57px;
    height: 11px;
    font-size: 11px;
    font-weight: 700;
    line-height: 11px;
    letter-spacing: 2px;
    color: #ffffff;
    padding-top: 23px;
  }
  .main .wrapper .activity-rule .activity-time {
    margin-left: 17px;
    margin-top: 30px;
  }
  .main .wrapper .activity-rule .activity-time img {
    width: 16px;
    height: 16px;
    margin-right: 14px;
    margin-top: -4px;
  }
  .main .wrapper .activity-rule .activity-time .time-title {
    width: 48px;
    height: 20px;
    font-size: 10px;
    line-height: 20px;
    letter-spacing: 2px;
    text-align: left;
    margin-right: 10px;
  }
  .main .wrapper .activity-rule .activity-time > p:last-child {
    width: 105px;
    height: 20px;
    font-size: 7px;
    line-height: 20px;
    letter-spacing: 1px;
  }
  .main .wrapper .activity-rule .activity-group {
    margin-left: 17px;
    margin-top: 14px;
  }
  .main .wrapper .activity-rule .activity-group img {
    width: 16px;
    height: 16px;
    margin-right: 14px;
    margin-top: -4px;
  }
  .main .wrapper .activity-rule .activity-group .group-title {
    width: 48px;
    height: 20px;
    font-size: 10px;
    line-height: 20px;
    letter-spacing: 2px;
    text-align: left;
    margin-right: 10px;
  }
  .main .wrapper .activity-rule .activity-group > p:last-child {
    width: 105px;
    height: 20px;
    font-size: 7px;
    line-height: 20px;
    letter-spacing: 1px;
  }
  .main .wrapper .activity-rule .prize-rule {
    margin-left: 17px;
    margin-top: 25px;
  }
  .main .wrapper .activity-rule .prize-rule.trialRule {
    margin-top: 25px;
  }
  .main .wrapper .activity-rule .activity-group + .prize-rule {
    margin-top: 13px;
  }

  .main .wrapper .activity-rule img {
    width: 16px;
    height: 16px;
    margin-right: 14px;
    margin-top: -4px;
  }
  .main .wrapper .activity-rule .prize-title {
    width: 132px;
    height: 20px;
    font-size: 10px;
    line-height: 20px;
    letter-spacing: 2px;
    text-align: left;
    margin-right: 10px;
  }
  .main .wrapper .activity-rule .first-title {
    width: 220px;
    margin-left: 46px;
    margin-top: 10px;
    text-align: left;
    letter-spacing: 0px;
    font-size: 7px;
  }
  .main .wrapper .activity-rule .first-title > span {
    font-size: 7px;
  }

  .main .wrapper .activity-rule .third-title + p {
    margin-top: -10px !important;
  }
  .main .wrapper .activity-rule .prize-content .left-content {
    margin-left: 46px;
  }
  .main .wrapper .activity-rule .prize-content .left-content > p {
    width: 56px;
    height: 7px;
    font-size: 7px;
    line-height: 7px;
    margin-top: 10px;
    margin-bottom: 5px;
    margin-left: -5px;
    letter-spacing: 1px;
  }
  .main .wrapper .activity-rule .prize-content .left-content .left-detail {
    width: 82px;
    height: 25px;
    border-radius: 1px;
    box-sizing: border-box;
  }
  .main .wrapper .activity-rule .prize-content .left-detail p {
    height: 7px;
    font-size: 7px;
    line-height: 25px;
    padding: 0;
    margin-left: 5px;
    letter-spacing: 0px;
    text-align: left;
  }
  .main .wrapper .activity-rule .prize-content .right-content .right-detail {
    width: 158px;
    height: 25px;
    border-radius: 1px;
    box-sizing: border-box;
  }
  .main .wrapper .activity-rule .prize-content .right-detail p {
    padding-left: 5px;
  }
  .main .wrapper .activity-rule .prize-content .right-content > p {
    width: 56px;
    height: 7px;
    font-size: 7px;
    line-height: 7px;
    margin-top: 10px;
    margin-bottom: 5px;
    letter-spacing: 1px;
  }
  .main .wrapper .activity-rule .prize-content .right-detail p:first-child {
    padding-top: 4px;
    width: 145px;
    height: 7px;
    font-size: 7px;
    line-height: 7px;
    letter-spacing: 0px;
  }
  .main .wrapper .activity-rule .prize-content .right-detail p:last-child {
    padding-top: 4px;
    padding-bottom: 4px;
    width: 158px;
    height: 7px;
    font-size: 7px;
    line-height: 7px;
    letter-spacing: 0px;
  }
  .main
    .wrapper
    .activity-rule
    .prize-content
    .right-content
    .right-detail.onlyone {
    padding-top: 5px;
  }
  .main .wrapper .activity-rule .first-title.multiline {
    line-height: 12px;
    margin-bottom: 27px;
  }
  .main .wrapper .activity-rule .first-title.last {
    margin-bottom: 20px;
  }
  .main .wrapper .activity-rule .first-title.subtitle {
    margin-left: 46px;
  }
  .main .wrapper .activity-rule .first-title.multiline2 {
    margin-bottom: 20px;
  }
  .main .wrapper .activity-rule .first-title.value-added-last {
    margin-top: -10px;
  }
  .main .wrapper .activity-rule .first-title.trial-code-last {
    margin-top: 0;
  }
  .main .wrapper .activity-rule .notices {
    width: 40px;
    height: 8px;
    font-size: 8px;
    line-height: 8px;
    letter-spacing: 2px;
    margin-left: 20px;
    margin-top: 30px;
  }
  .main .wrapper .activity-rule .first-title.notices-last {
    margin-top: -25px;
  }
  .main .wrapper .activity-rule .notices p:first-child {
    line-height: 19px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ActivityPage.vue